
import MyCheckCreditReformResult from '~/components/marketplace/my_checks/MyCheckCreditReformResult.vue'

export default {
  name: `MyCheckIDResult`,
  extends: MyCheckCreditReformResult
}
